<template>
    <div>
        <main>
            <router-view />
        </main>

        <footer>
            <ComponentFooter />
        </footer>
    </div>
</template>

<script>

import ComponentFooter from '../components/client/ComponentFooter.vue';

export default {
    components: {
        ComponentFooter
    },
    name: 'LayoutDefault',
}
</script>

<style scoped>
@media (max-width: 767px) {
    main {
        margin-bottom: 50px;
    }
}
</style>